import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FacadeService } from '@core/facade/facade.service';
import { Utils } from '@core/utils/utils';

@Component({
  selector: 'product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
})
export class ProductCardComponent implements OnInit {
  fav: boolean = false;
  cart: boolean = false;

  @Output() deletedItem = new EventEmitter<any>();


  @Input() image!: string;
  @Input() name!: string;
  @Input() price!: number;
  @Input() salePrice!: number;
  @Input() id!: string;
  @Input() wishList!: string;
  @Input() favouriteId!: string;
  @Input() index!: number;
  @Input() reviews!: any[];
  @Input() categoryId!: string;
  @Input() colors!: string;
  @Input() type!: string;
  @Input() qty!:string;

  util = new Utils();

    currency: any;
    addedToFav: boolean = false;
    cartAdd!: boolean;

    viewSalPrice!: number;
    overallRating: any;

    constructor(
      private facade: FacadeService
      ) {
        this.currency = JSON.parse(sessionStorage.getItem('currency')!);
        this.currency = this.currency[0]
    }

    ngOnInit(): void {
    }

    addToFavorite() {
      if (localStorage.getItem('AUTH_TOKEN')) {
        const variables = {
          addToFavouriteInput: {
            variantId: this.id
          }
        }
        this.facade.addFavorite(variables).subscribe((res: any) => {
          if (res) {
            this.facade.success('Success');
            this.sendFaveItemToFaveNotification(res);
            this.addedToFav = true;
            // localStorage.setItem('FAV_NOTIFICATION', localStorage.getItem('FAV_NOTIFICATION') );
          }
        }, (error: any) => {
          this.facade.handleError(error);
        });
      } else {
        localStorage.setItem('redirectTo', this.facade.url())
        this.facade.navigate(['/auth'], {
          queryParams: { subCategoryId: this.id },
        });
      }
    }

    addProduct() {
      this.cartAdd = true;
      const variables = {
        addToCartInput: {
          variantId: this.id,
          cartId: localStorage.getItem('cartId') ? localStorage.getItem('cartId') : localStorage.getItem('cartId_Guest'),
        },
      };
      this.facade.addToCart(variables).subscribe((res: any) => {
        this.cartAdd = false;
        if (res) {
          this.facade.cartOverlayToggle();
          localStorage.setItem('CART_LENGTH',res.data.addToCart.cartDetails)
          this.sendCartItemsToCartNotifications(res.data.addToCart.cartDetails);
          this.facade.success(`Added To Cart Succesfully`);
        }
      }, (error: any) => {
        this.cartAdd = false;

        this.ifNoSuchCart(error);
        // this.facade.handleError(error);

      });
    }

    ifNoSuchCart(error: any) {
      if (error?.graphQLErrors[0]?.extensions?.response?.statusCode == 404) {
        if(error?.graphQLErrors[0]?.extensions?.response?.message?.includes('no enough quantity')){
          this.facade.info(error?.graphQLErrors[0]?.extensions?.response?.message);
        }else {
          localStorage.removeItem('cartId');
          this.facade.removeItem('cartId_Guest');
          this.facade.createCart().then((res: any) => {
            if (res) {
              this.addProduct();
            }
          })
        }

      }
    }

    addProductToCart() {
      if (localStorage.getItem('cartId') || localStorage.getItem('cartId_Guest')) {
        this.addProduct();
      } else {
        this.facade.createCart().then((res: any) => {
          this.addProduct();
        });
      }
    }

    deleteItemFromFave() {
      const variables = {deleteFavouriteInput: {favouriteId: this.favouriteId}}
      this.facade.deleteBuyerWithoutInputVar(variables).subscribe((res: any) => {
        if (res) {
          this.addNewItem();
          this.facade.success('Success');
          this.sendFaveItemToFaveNotification(res);
        }
      });
    }

    changeVariantBasedOnColor(variant: any) {
      this.image = variant?.variant?.frontImage;
      this.name = variant?.variant?.name;
      this.price = variant?.variant?.price;
      this.salePrice = variant?.variant?.salePrice;
      this.reviews = variant?.variant?.reviews;
      this.id = variant?.variant?.variantId;


    }

    ngOnChanges(change: SimpleChanges) {
      if(change?.reviews && change?.reviews.currentValue) {
        this.overallRating = this.util.getOverallRating(change?.reviews?.currentValue);
      }

    }

    addNewItem(index?: number) {
      this.deletedItem.emit(this.index);
    }


    sendFaveItemToFaveNotification(data: any) {
      this.facade.nextFave(data);
    }

    sendCartItemsToCartNotifications(res: any) {
      this.facade.nextCount(res);
    }

    gotoProductDetail() {
      this.facade.navigate(['/product', this.util.createSlug(this.name , this.id) ]);
    }


    goToCategoryProduct() {
      if(this.type == 'wearMood') {
        this.goToWearMoodProduct();
      } else {
      this.facade.navigate(['/category'], { queryParams: { categoryId: this.util.createSlug(this.name, this.categoryId) } })
      }

    }

    goToWearMoodProduct() {
      this.facade.navigate(['/category'], { queryParams: { wearMoodId: this.util.createSlug(this.name, this.categoryId) } })

    }


    navigate() {
      if (this.wishList == 'wishList') {
        this.gotoProductDetail();
      } else if (this.wishList == 'category') {
          this.goToCategoryProduct();
      } else {
        this.gotoProductDetail();
      }
    }
}
